module.exports = __webpack_public_path__ + "img/fwlcBanner.aff165c9.png";